import { useEffect, useState } from 'react';
import MassketteDiagram from '../MassketteDiagram';
import SketchPanel from './SketchPanel';
import ViewSwitch from './ViewSwitch';
import HideButton from './HideButton';
import { useAuthStore } from '../../../stores/authStore';
import { useProjectStore } from '../../../stores/projectStore';
import { useTourStore } from '../../../tour/tourStore';
import { reportError } from '../../../lib/sentry';
import { viewFromProfile, effectiveView } from './sketchView';

// Oberer Bereich der Rechenseite (C7): Maßkette, Skizze oder beides.
// Die Wahl liegt im Konto (profiles.sketch_view); Umschalten speichert sofort.
// Umschalter und Ausblenden sitzen immer in der rechten Kopfzeile.
export default function KetteUndSkizze({ onHide }) {
  const profilWert = useAuthStore((s) => s.profile?.sketch_view);
  const updateProfile = useAuthStore((s) => s.updateProfile);
  const tourAktiv = useTourStore((s) => s.aktiv);
  const hatSkizze = useProjectStore((s) => !!s.currentCalculation?.sketch_url);
  const [view, setView] = useState(() => viewFromProfile(profilWert));

  // Profil kommt nach dem Login oder ändert sich in den Einstellungen.
  useEffect(() => { setView(viewFromProfile(profilWert)); }, [profilWert]);

  const waehlen = (v) => {
    setView(v);
    updateProfile({ sketch_view: v })
      .catch((err) => reportError(err, { where: 'sketch_view speichern' }));
  };

  const sicht = effectiveView(view, { tourAktiv });
  const controls = (
    <>
      <ViewSwitch value={sicht} onChange={waehlen} />
      {onHide && <HideButton onClick={onHide} />}
    </>
  );
  const spalte = { minWidth: 0, display: 'flex', flexDirection: 'column', gap: 12 };

  if (sicht === 'kette') return <MassketteDiagram controls={controls} />;
  if (sicht === 'skizze') return <div style={spalte}><SketchPanel controls={controls} /></div>;
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'stretch' }}>
      <div style={{ ...spalte, flex: 1 }}><MassketteDiagram /></div>
      {/* Ohne Skizze so breit wie die Kopfzeile, damit Umschalter und
          Ausblenden nicht umbrechen; die Kachel wird so hoch wie die Kette. */}
      <div style={{ ...spalte, flex: hatSkizze ? '0 0 40%' : '0 0 auto', minWidth: hatSkizze ? 0 : 300 }}>
        <SketchPanel controls={controls} compact={!hatSkizze} />
      </div>
    </div>
  );
}
